<template>
  <div id="SearchFieldBlock">
    <v-autocomplete
      class="pa-0"
      ref="SearchField"
      id="SearchField"
      v-model="linkName"
      :items="items"
      outlined
      dense
      light
      hide-details
      hide-spin-buttons
      auto-select-first
      clearable
      loader-height="0"
      placeholder="管理画面を検索する [ctrl + shift + k]"
      background-color="#fff"
      item-text="jaName"
      item-value="name"
      :filter="filter"
      @input="transitionScreen"
      :menu-props="{ maxHeight: 200 }"
    >
      <template v-slot:prepend-inner>
        <span
          v-if="linkName"
          style="
            font-size: 0.9rem;
            color: #000;
            width: 44px;
            margin-top: 3px;
            margin-right: -5px;
          "
        >
          検索：
        </span>
      </template>
      <template v-slot:append>
        <div class="v-input__icon v-input__icon--clear">
          <button @click.prevent="transitionScreen" style="cursor: pointer">
            <v-icon>mdi-magnify</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            お探しのページは見つかりませんでした
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'HeaderSearchFieldContainer',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      linkName: null,
      filter: (item, queryText, itemText) => {
        return (
          item.searchValue.includes(queryText) || itemText.includes(queryText)
        )
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', (event) => {
      // ctrl + shift + k ショートカット
      if (event.ctrlKey && event.shiftKey && event.code === 'KeyK' && this.$refs.SearchField) {
        this.$refs.SearchField.focus()
      }
    })
  },
  methods: {
    transitionScreen () {
      if (!this.linkName || this.$route.name === this.linkName) return

      this.$router.push({ name: this.linkName })
      this.$refs.SearchField.blur()
    }
  }
}
</script>

<style>
#SearchFieldBlock > * {
  min-height: 35px !important;
  height: 35px !important;
}

#SearchFieldBlock
  > .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box.v-select--chips--small.v-input--dense
  .v-select__selections,
#SearchFieldBlock
  > .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-select--chips--small.v-input--dense
  .v-select__selections {
  min-height: 35px !important;
}
#SearchFieldBlock > .v-text-field.v-text-field--enclosed .v-text-field__details,
#SearchFieldBlock
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  min-height: 35px !important;
}

#SearchFieldBlock .v-select__selections {
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
}

#SearchFieldBlock .v-select__slot {
  margin: auto;
  min-height: 35px !important;
  height: 35px !important;
}

#SearchFieldBlock .v-input__append-inner {
  margin-top: auto;
  min-height: 29px !important;
  height: 29px !important;
}

#SearchField {
  padding-top: 10px;
  font-size: .9rem;
}

#SearchField::placeholder {
  height: 100%;
  width: 100%;
  text-align: center;
  font-size: 0.8rem;
  line-height: normal;
}
</style>
